import { getOwner } from '@ember/owner';

const getAnalyticService = (scope) =>
  getOwner(scope).lookup('service:analytics');

export const trackPageViewFromTransition = (scope, ...args) =>
  getAnalyticService(scope).trackPageViewFromTransition(...args);

export const trackEvent = (scope, ...args) =>
  getAnalyticService(scope).trackEvent(...args);

export const trackEventAsync = (scope, ...args) =>
  getAnalyticService(scope).trackEventAsync(...args);

export const setUserId = (scope, ...args) =>
  getAnalyticService(scope).setUserId(...args);

/**
 * Track an analytics event in FullStory
 *
 * @param {string} eventName name of the event
 * @param {userId|null} userId id of User or null for guests
 * @param {object} data properties to track
 */
export const storeDataOnEvent = (eventName, userId, data) => {
  window.FS.event(eventName, { userId, ...data });
};
